/* eslint-disable */
var $ = window.jQuery = require('jquery');
import toast from '../../services/toast';
import { VueEditor } from "vue2-editor";
import {
  bus
} from '../../main';
import {
  mapGetters,
  mapState
} from 'vuex';
export default {
  name: 'add-assignment',
  components: {
    VueEditor
  },
  props: ['assignmentID'],
  data() {
    return {
      name: '',
      description: '',
      course: '',
      course_section: '',
      SectionName: '',
      submitted: false,
      uploadAssignmentNameLowercase: '',
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold','italic','link',  '|', 'heading', 'fontFamily','fontSize','undo','redo']
      },
      editorData:''
    }
  },
  computed: {
    ...mapGetters([
      'getsectionbycourseIDState',
      'getcourseSectionByIDDataState'
    ]),
    getCourseSectionDataByID() {
      this.$store.dispatch('get_course_section_fun', {
        id: this.assignmentID
      }).then((res) => {
        this.SectionName = this.$store.getters.getcourseSectionByIDDataState.data.name;
        this.uploadAssignmentNameLowercase = this.SectionName.toLowerCase();
      }).catch((err) => {})
    }
  },
  mounted() {
    this.getCourseSectionDataByID
  },
  methods: {
    getCourseDetailsAgain() {
      this.$store.dispatch('sectionbycourseId', {
        id: this.$route.params.id
      }).then((res) => {
        bus.$emit('HideAddAssignmentPopup', false)
      }).catch((err) => {})
    },
    validateAssignmentBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
            course: this.$route.params.id,
            course_section: this.assignmentID,
            name: this.name,
            description: this.description
          }
          this.$store.dispatch('createAssignment', data)
            .then((res) => {
              this.getCourseDetailsAgain();
              this.name = '';
              this.description = '',
              toast.success(res.data.msg);
              this.$validator.reset();
            })
            .catch((err) => {})
          return
        }
      });
    },
    popupCloseFun() {
      bus.$emit('HideAddAssignmentPopup', false)
    },
  }
}